// extracted by mini-css-extract-plugin
export default {"ProfilePicture":"ProfilePicture_ProfilePicture__FHblU","ProfilePictureOuter":"ProfilePicture_ProfilePictureOuter__LoCV+","center":"ProfilePicture_center__+76c6"};